import {
  EOrderStatus,
  IGetOrdersResponse,
  IMappedOrder,
  IMappedOrderItem,
  IOrderItemResponse,
  IOrderResponse,
} from "./orders.interface";

const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

const formatPrice = (amount: number): string => {
  return amount.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const mapOrderItem = (item: IOrderItemResponse): IMappedOrderItem => ({
  id: item.id,
  name: item.productName,
  petId: item.petId,
  petName: item.petName,
  price: formatPrice(item.price),
  quantity: item.quantity,
  productUrl: item.productUrl,
  imageUrl: item.imageUrl,
});

const mapOrder = (order: IOrderResponse): IMappedOrder => ({
  id: order.id,
  orderNumber: order.orderNumber,
  status: order.status.toUpperCase() as EOrderStatus,
  date: formatDate(order.orderDate),
  total: formatPrice(order.subtotal + order.tax),
  items: order.items.map(mapOrderItem),
  trackingNumber: order.trackingNumber,
  vetCoveUrl: order.vetCoveUrl,
});

export const mapOrdersResponse = (data?: IGetOrdersResponse) => {
  const orders = data?.getOnlinePharmacyOrders?.orders.map(mapOrder) ?? [];

  return {
    ordersUrl: data?.getOnlinePharmacyOrders?.ordersUrl,
    subscriptionsUrl: data?.getOnlinePharmacyOrders?.subscriptionsUrl,
    orders,
    hasMore: data?.getOnlinePharmacyOrders?.hasMore ?? false,
    pageNumber: data?.getOnlinePharmacyOrders?.pageNumber ?? 0,
    totalCount: data?.getOnlinePharmacyOrders?.totalCount ?? 0,
    pageSize: data?.getOnlinePharmacyOrders?.pageSize ?? 0,
  };
};
